import {getFormData} from '../../../../utilities/helper/formDataConvertor';
import request from '../../../axios';

const postSendMessage = async (payload: ISendMessagePayload, guid?: string) => {
  await request.post(
    `/api/v2/shop/chat/${guid}/messages`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
  );
};

export default postSendMessage;
